// extracted by mini-css-extract-plugin
module.exports = {"pageNotFoundContainer":"ErrorPagesLayout_pageNotFoundContainer__20-N1","mainContainer":"ErrorPagesLayout_mainContainer__O6aEB"};